import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AccordionService } from '../services/accordion.service';

@Component({
  selector: 'app-claim-name-search',
  templateUrl: './claim-name-search.component.html',
  styleUrls: ['./claim-name-search.component.scss']
})
export class ClaimNameSearchComponent
  implements OnInit {

  @Input() public group: FormGroup;
  @Input() public accordionGroupName: string; // = 'name';

  constructor(private accordionService: AccordionService) { }

  ngOnInit() {
    ['policyHolderName', 'claimantName']
      .forEach((name) => this.accordionService.addFormControl(this.accordionGroupName, this.group, name));
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-list/claim-name-search/claim-name-search.component.ts